import { render, staticRenderFns } from "./logisticsOrderDetail.vue?vue&type=template&id=718d7c90&scoped=true"
import script from "./logisticsOrderDetail.vue?vue&type=script&lang=js"
export * from "./logisticsOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./logisticsOrderDetail.vue?vue&type=style&index=0&id=718d7c90&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718d7c90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('718d7c90')) {
      api.createRecord('718d7c90', component.options)
    } else {
      api.reload('718d7c90', component.options)
    }
    module.hot.accept("./logisticsOrderDetail.vue?vue&type=template&id=718d7c90&scoped=true", function () {
      api.rerender('718d7c90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderManagement/logisticsOrderList/logisticsOrderDetail.vue"
export default component.exports